import { COUNTRY_CONSTANT } from "../constants/countryConstants";

export const getCountries = (search = "") => ({
  type: COUNTRY_CONSTANT.GET_COUNTRIES_REQUEST,
  payload: { search },
});
